var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "envioDTE" } }, [
      _c("div", { staticClass: "centerx" }, [
        _c("div", { staticClass: "vx-row mb-2" }, [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|email",
                    expression: "'required|email'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  label: "Correo del destinatario",
                  maxlength: "100",
                  type: "email",
                  name: "destinatario"
                },
                model: {
                  value: _vm.envio.destinatario,
                  callback: function($$v) {
                    _vm.$set(_vm.envio, "destinatario", $$v)
                  },
                  expression: "envio.destinatario"
                }
              }),
              _vm.getError("destinatario")
                ? _c(
                    "span",
                    { staticClass: "text-danger text-sm form-error-message" },
                    [_vm._v("Debe ingresar un email válido")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _c("div", { staticClass: "vx-row mb-5" }, [
          _c(
            "div",
            { staticClass: "vx-col md:w-1/3 w-full" },
            [
              _c(
                "vs-checkbox",
                {
                  attrs: { color: "danger" },
                  model: {
                    value: _vm.envio.adjuntarXml,
                    callback: function($$v) {
                      _vm.$set(_vm.envio, "adjuntarXml", $$v)
                    },
                    expression: "envio.adjuntarXml"
                  }
                },
                [_vm._v("Adjuntar XML")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col md:w-1/3 w-full" },
            [
              _c(
                "vs-checkbox",
                {
                  attrs: { color: "danger" },
                  model: {
                    value: _vm.envio.adjuntarPdf,
                    callback: function($$v) {
                      _vm.$set(_vm.envio, "adjuntarPdf", $$v)
                    },
                    expression: "envio.adjuntarPdf"
                  }
                },
                [_vm._v("Adjuntar PDF")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col md:w-1/3 w-full" },
            [
              _c(
                "vs-checkbox",
                {
                  attrs: { color: "danger" },
                  model: {
                    value: _vm.envio.recibirCopia,
                    callback: function($$v) {
                      _vm.$set(_vm.envio, "recibirCopia", $$v)
                    },
                    expression: "envio.recibirCopia"
                  }
                },
                [_vm._v("Recibir Copia")]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "vx-row mb-2 mt-2" }, [
          _c(
            "div",
            { staticClass: "vx-col w-full" },
            [
              _c("vs-input", {
                staticClass: "w-full",
                attrs: {
                  label: "Copias (correos electrónicos separados por coma)",
                  maxlength: "150",
                  type: "email",
                  name: "copias"
                },
                model: {
                  value: _vm.envio.copias,
                  callback: function($$v) {
                    _vm.$set(_vm.envio, "copias", $$v)
                  },
                  expression: "envio.copias"
                }
              })
            ],
            1
          )
        ]),
        _c("br"),
        _c(
          "div",
          [
            _c("vs-textarea", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required|min:10",
                  expression: "'required|min:10'"
                }
              ],
              attrs: { label: "Mensaje", name: "mensaje" },
              model: {
                value: _vm.envio.mensaje,
                callback: function($$v) {
                  _vm.$set(_vm.envio, "mensaje", $$v)
                },
                expression: "envio.mensaje"
              }
            }),
            _vm.getError("mensaje")
              ? _c(
                  "span",
                  { staticClass: "text-danger text-sm form-error-message" },
                  [_vm._v("Debe definir un mensaje de al menos 10 caracteres")]
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _c("div", { attrs: { align: "right" } }, [
      _c(
        "div",
        [
          _c(
            "vs-button",
            {
              attrs: { color: "primary", type: "filled submit" },
              on: { click: _vm.enviarDte }
            },
            [_vm._v("Enviar")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }